import { render, staticRenderFns } from "./PageNotiRegistered.vue?vue&type=template&id=bd83d3cc&scoped=true&"
import script from "./PageNotiRegistered.vue?vue&type=script&lang=js&"
export * from "./PageNotiRegistered.vue?vue&type=script&lang=js&"
import style0 from "./PageNotiRegistered.vue?vue&type=style&index=0&id=bd83d3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd83d3cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFlex,VMain,VRow})
